import { createApp, h, type Component } from 'vue'

type MountedVueInLeaflet = {
  el: HTMLElement
  destroy: () => void
}

/**
 * Монтирует Vue-компонент в DOM-элемент для последующей вставки в Leaflet marker/icon.
 * Возвращает обязательный destroy, который нужно вызвать перед удалением Leaflet layer.
 *
 * @param component — Vue-компонент для рендера внутри Leaflet DOM
 * @param props — props компонента
 * @returns DOM-элемент и функция размонтирования Vue app
 */
export const mountVueInLeaflet = (
  component: Component,
  props: Record<string, unknown> = {},
): MountedVueInLeaflet => {
  const el = document.createElement('div')
  const app = createApp({
    render: () => h(component, props),
  })
  let isDestroyed = false

  app.mount(el)

  return {
    el,
    destroy: () => {
      if (isDestroyed) return

      app.unmount()
      el.remove()
      isDestroyed = true
    },
  }
}
